export const LISTCONTACT_FOLDER_REQUEST="LISTCONTACT_FOLDER_REQUEST"
export const LISTCONTACT_FOLDER_SUCCESS="LISTCONTACT_FOLDER_SUCCESS"
export const LISTCONTACT_FOLDER_FAIL="LISTCONTACT_FOLDER_FAIL"